module.exports = __webpack_public_path__ + "img/num05.307a2151.png";